<p>buyer-logout works!</p>
